import request from '@/utils/request'
// 获取服务单详情
export function getServiceDetail(guid: string) {
  return request.get(`/api/agri/after_sales/${guid}`)
}
// 获取维修网点列表
export function getServiceNetWork(params = {}) {
  return request.get('/api/agri/common/repair_warehouses', { params: params })
}
// 更改维修网点
export function changeServiceNetWork(guid: string, editJson = {}) {
  return request.post(`/api/agri/after_sales/${guid}/exchange`, editJson)
}
// 取消维修单
export function cancelService(guid: string) {
  return request.post(`/api/agri/after_sales/${guid}/cancel`)
}
// 上传图片
export function uploadImages(createJson = {}) {
  return request.post('/api/agri/common/images', createJson)
}
// 获取设备日志信息
export function getDeviceLogs(params = {}) {
  return request.get('/api-protection/uav_logs', { params: params })
}
// 全保审核申诉
export function appealAllProtect(guid: string, addJson = {}) {
  return request.post(`/api/agri/after_sales/qualitative/${guid}/appeal`, addJson)
}
// 定责审核申诉
export function appealDzProtect(guid: string, editJson = {}) {
  return request.post(`/api/agri/after_sales/responsibilities/${guid}/appeal`, editJson)
}
// 定责审核确认
export function approveDzOrder(guid: string, editJson = {}) {
  return request.post(`/api/agri/after_sales/responsibilities/${guid}/confirm`, editJson)
}
export function approveAllProtect(guid: string, editJson = {}) {
  return request.post(`/api/agri/after_sales/qualitative/${guid}/confirm`)
}
// 获取维修单详情
export function getRepairDetail(param = {}) {
  return request.get('/api/agri/repair/repair_order_detail', { params: param })
}
// 确认维修单
export function confirmRepairOrder(editJson = {}) {
  return request.post('/api/agri/repair/confirm_estimate', editJson)
}
// 维修单检测情况
export function checkRepairOrderDetail(params = {}) {
  return request.get(`/api/agri/repair/get_detect_info`, { params: params })
}
// 通过图片uuid获取图片url地址
export function getImageUrlByUuid(uidsJson = {}) {
  return request.post('/api/agri/common/images/urls', uidsJson)
}
// 通过guid获取备用机单详情
export function getBYJDetailByGuid(params = {}) {
  return request.get('/api/agri/agriculture_backup_machine/backup_machine_detail', {
    params: params,
  })
}
// 通过备用机sn获取备用机时长
export function getTimeByBYJSn(params = {}) {
  return request.get('/api/agri/agriculture_backup_machine/purchase_time', { params: params })
}
// 获取网点详情信息(经纬度等)
export function getNetWorkByGuid(guid: string, params = {}) {
  return request.get(`/api/agri/common/repair_warehouses/${guid}`, { params: params })
}
// 备用机订单状态操作
export function byjOrderOperate(editJson = {}) {
  return request.post('/api/agri/agriculture_backup_machine/operate_step', editJson)
}
// 维修单支付操作
export function payRepairOrder(editJson = {}) {
  return request.post('/api/agri/repair/pay', editJson)
}
// 备用机单支付操作
export function payReserveOrder(editJson = {}) {
  return request.post('/api/agri/agriculture_backup_machine/purchase_pay', editJson)
}

// 查询维修单支付状态
export function searchPayStatus(params = {}) {
  return request.get('/api/agri/repair/repair_order_is_pay', { params: params })
}
// 查询备用机单支付状态
export function searchByjPayStatus(params = {}) {
  return request.get('/api/agri/agriculture_backup_machine/purchase_payment_status', {
    params: params,
  })
}
// 评价服务单
export function evalUateServiceOrder(guid: string, editJson = {}) {
  return request.post(`/api/agri/after_sales/${guid}/appraise`, editJson)
}
